import React from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { PeekBox, PeekButton } from "@piiqtechnologies/ui-components";
export const EditRequestActions = ({ isCancelRequestForm, toggleCancelRequestForm }) => {
    const intl = useIntl();
    if (isCancelRequestForm)
        return (React.createElement(React.Fragment, null,
            React.createElement(PeekBox, { onClick: toggleCancelRequestForm },
                React.createElement(PeekButton, { size: "large", color: "primary", variant: "contained", fullWidth: true }, intl.formatMessage(messages.backCancelRequest))),
            React.createElement(PeekButton, { type: "submit", size: "large", color: "error", variant: "outlined", fullWidth: true }, intl.formatMessage(messages.confirmCancelRequest))));
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekButton, { type: "submit", size: "large", color: "primary", variant: "contained", fullWidth: true }, intl.formatMessage(messages.saveEditRequest)),
        React.createElement(PeekBox, { onClick: toggleCancelRequestForm },
            React.createElement(PeekButton, { size: "large", color: "error", variant: "outlined", fullWidth: true }, intl.formatMessage(messages.cancelRequest)))));
};
export default EditRequestActions;
